import { useCallback, useState } from 'react';

const getStorage = (): Storage | null => (typeof window === 'undefined' ? null : window.localStorage);

// Pass `ttlMs` for a timed dismissal: the hook stores an expiry timestamp and reads back
// "dismissed" only until it passes. Without it, dismissal is a boolean that persists indefinitely.
export const usePromptDismissal = (storageKey: string, ttlMs?: number): [boolean, (value: boolean) => void] => {
  const [promptShown, setPromptShown] = useState<boolean>(() => {
    try {
      const raw = getStorage()?.getItem(storageKey);
      return ttlMs ? Number(raw) > Date.now() : raw === 'true';
    } catch (e) {
      console.warn('storage access denied:', e);
      return false;
    }
  });

  const setPromptShownAndStore = useCallback(
    (value: boolean) => {
      try {
        const storage = getStorage();
        if (ttlMs) {
          if (value) storage?.setItem(storageKey, String(Date.now() + ttlMs));
          else storage?.removeItem(storageKey);
        } else {
          storage?.setItem(storageKey, String(value));
        }
      } catch (e) {
        console.warn('storage access denied:', e);
      }
      setPromptShown(value);
    },
    [storageKey, ttlMs],
  );

  return [promptShown, setPromptShownAndStore];
};
